import { render, staticRenderFns } from "./clnt_research.vue?vue&type=template&id=4d690108&scoped=true&"
import script from "./clnt_research.vue?vue&type=script&lang=js&"
export * from "./clnt_research.vue?vue&type=script&lang=js&"
import style0 from "./clnt_research.vue?vue&type=style&index=0&id=4d690108&scoped=true&lang=less&"
import style1 from "./clnt_research.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d690108",
  null
  
)

export default component.exports